import { create } from "zustand";

const useCoverLogoStore = create((set) => ({
    logo: '',
    setLogo: (newLogo) => set(() => ({ logo: newLogo })),
}));

export default useCoverLogoStore;
